export default __webpack_public_path__ + "static/clothing_haircuts-6433b40fac5d617078aa97e70cf9aa70.png";